import { getClient, initClientWithFetch } from '~/lib/contensis/client'
import { Op, Query } from 'contensis-delivery-api'
import { isDevelopment } from '~/utils/misc'
import { cleanTerms, standard } from '~/content-types/~queries/search/lib/misc'

initClientWithFetch()

export const SearchData = async (
  value: string,
  size: number,
  type: string[] | [],
  keyword = ''
) => {
  const client = getClient()

  const trimmed = value.trim()
  if (!trimmed) return null

  const terms = cleanTerms(trimmed)

  const fields = [
    'entryTitle',
    'seoStandard.title',
    'seoStandard.description',
    'seoStandard.search',
    'sys.id',
    'sys.uri',
    'sys.contentTypeId',
    'sys.version',
    'searchContent'
  ]

  const query = new Query(
    Op.equalTo('sys.versionStatus', isDevelopment ? 'latest' : 'published'),
    Op.equalTo('seoStandard.search', true),
    standard(trimmed, terms)
  )

  if (keyword || type) {
    // Build an array of expressions for content type filters
    const types =
      type.length > 0 ? type.map(ct => Op.equalTo('sys.contentTypeId', ct)) : []

    // Only include types if not empty
    if (types.length > 0) {
      query.where.add(
        Op.and(Op.freeText('searchContent', keyword), Op.or(...types))
      )
    } else {
      query.where.add(Op.and(Op.freeText('searchContent', keyword)))
    }
  }

  query.pageSize = size
  query.fields = fields

  // query.orderBy = OrderBy.asc('sys.version.publihed')

  try {
    const result = await client.entries.search(query, 1)

    // console.log('API Response:', result)

    if (!result || !result.items) {
      console.error('No items found in the response')
      return []
    }

    return result.items
  } catch (err) {
    console.error('Error during search:', err)
    return []
  }
}
